/* @flow */
import React from 'react';

import BoxBody from 'components/BoxBody.jsx';
import BoxHeader from 'components/BoxHeader.jsx';
import Glyph from 'components/Glyph.jsx';
import Group from 'entities/Group';
import Image from 'components/Image.jsx';
import Languages from 'lib/Languages.js';
import LayerTrigger from 'components/LayerTrigger.jsx';
import Link from 'components/Link.jsx';
import Menu from 'components/Menu.jsx';
import MenuItem from 'components/MenuItem.jsx';
import PDFDownload from 'components/PDFDownload.jsx';
import TabPanel from 'components/TabPanel.jsx';

import './styles/InvitePDFTab.scss';

const PDF_LOCALES: Array<string> = [
  'en',
  'es-419',
  'es-ES',
  'fr-FR',
  'fr-CA',
  'pt-BR',
];

const DEFAULT_PDF_LOCALE: string = 'en';

class InvitePDFTab extends React.Component {
  props: {
    group: Group,
    title: mixed,
  }

  state: {
    locale: String,
  }

  state = {
    locale: DEFAULT_PDF_LOCALE,
  }

  setLocale = (locale: string): void => {
    this.setState({ locale });
  }

  renderDownloadButton() {
    return (
      <PDFDownload
        type="button"
        group={this.props.group}
        locale={this.state.locale}
        level="primary">
        Download PDF
      </PDFDownload>
    );
  }

  renderHeader() {
    const title = (
      <span>
        PDF instructions on how to join <span className="InvitePDFTab-groupName">{this.props.group.getName()}</span>
      </span>
    );
    return (
      <BoxHeader title={title} />
    );
  }

  renderLocaleDropdown() {
    return (
      <LayerTrigger
        layer={this.renderLocaleOptionsMenu()}
        trigger="click"
        placement="top"
        alignment="middle">
        <Link href="#" color="inherit">
          <span className="InvitePDFTab-locale-label">
            {Languages[this.state.locale].name}
          </span>
          <Glyph name="chevron-down" size="xxsmall" />
        </Link>
      </LayerTrigger>
    );
  }

  renderLocaleOptionsMenu() {
    const menuItems = PDF_LOCALES.map(locale => {
      return (
        <MenuItem
          eventElementName={'Pdf-download-link'}
          eventProperties={{
            screen_name: 'InvitePDFTab',
            foreign_table: 'groups',
            foreign_id: this.props.group.id,
            locale,
          }}
          key={locale}
          onSelect={this.setLocale}>
          {Languages[locale].name}
        </MenuItem>
      );
    });

    return (
      <Menu selectedKey={this.state.locale}>
        {menuItems}
      </Menu>
    );
  }

  render() {
    return (
      <TabPanel
        className="InvitePDFTab"
        key="smsPanel"
        selectedBorderColor="lava"
        eventElementName="tab-printable-pdf"
        title={this.props.title}>
        {this.renderHeader()}
        <BoxBody>
          <div>
            <Image
              src={require('assets/images/GroupInviteModal/mobile_join_pdf.png')}
              className="InvitePDFTab-img"
            />
          </div>
          <div className="InvitePDFTab-language">
            {'Language: '}
            {this.renderLocaleDropdown()}
          </div>
          {this.renderDownloadButton()}
        </BoxBody>
      </TabPanel>
    );
  }
}

export default InvitePDFTab;



// WEBPACK FOOTER //
// ./src/groups/components/InvitePDFTab.jsx